import { TGetHistoryRenewVisaDocumentGroupListOutputDto } from "@/api/services/main/renew-visa/dtos/get-history-renew-visa-document-group-list.dto";
import { Button } from "@/components/elements/Button";
import { DATE_FORMAT } from "@/constants/datetime";
import { EMPTY_STR } from "@/constants/string";
import { AppRoutes } from "@/routes/config";
import { dayjs } from "@/utils/dayjs";
import { getFullName, truncateWithEllipsis } from "@/utils/string";
import { getDynamicRoute } from "@/utils/url";
import { Typography } from "@mui/material";
import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { Link } from "react-router-dom";

type UseMakeHistoryRenewVisaColumnsReturn = MRT_ColumnDef<TGetHistoryRenewVisaDocumentGroupListOutputDto>[];

export const useMakeHistoryRenewVisaColumns = (): UseMakeHistoryRenewVisaColumnsReturn => {
  const columns = useMemo<MRT_ColumnDef<TGetHistoryRenewVisaDocumentGroupListOutputDto>[]>(
    () => [
      {
        header: "申請日",
        Cell: ({ row }) => (row.original.applicationDate ? dayjs(row.original.applicationDate).format(DATE_FORMAT) : EMPTY_STR.DATE),
      },
      {
        header: "申請番号",
        Cell: ({ row }) => row.original.applicationNumber || EMPTY_STR.TEXT,
      },
      {
        header: "外国人名",
        Cell: ({ row }) => {
          const { firstName, lastName, middleName } = row.original.employee;
          const fullName = getFullName({ firstName, lastName, middleName });

          return <Typography variant="body14"> {fullName ? truncateWithEllipsis(fullName, 26) : EMPTY_STR.TEXT}</Typography>;
        },
      },
      {
        header: "最終更新日",
        Cell: ({ row }) => (row.original.updatedAt ? dayjs(row.original.updatedAt).format(DATE_FORMAT) : EMPTY_STR.DATE),
      },
      {
        header: "最終更新者",
        Cell: ({ row }) => row.original.updater?.fullName || EMPTY_STR.TEXT,
      },
      {
        id: "action",
        header: "",
        Cell: ({ row }) => {
          const { employeeRenewVisaDocumentGroupId: historyEmployeeRenewVisaDocumentGroupId } = row.original;

          return (
            <Button
              variant="outline"
              size="sm"
              component={Link}
              to={getDynamicRoute(AppRoutes.renewVisaInfoHistoryDetail, {
                employeeRenewVisaDocumentGroupId: historyEmployeeRenewVisaDocumentGroupId,
              })}
            >
              確認
            </Button>
          );
        },
        size: 50,
        muiTableBodyCellProps: {
          sx: { width: "10%" },
        },
      },
    ],
    [],
  );

  return columns;
};
